(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["xfun-collection-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.XfunCategoryNavigation) {
      window.XfunCategoryNavigation.initialize(document);
      return;
    }
    const states = new WeakMap();
    const activeStates = new Set();
    const read = (key) => {
      try { return JSON.parse(sessionStorage.getItem(key)); } catch (_) { return null; }
    };
    const write = (key, value) => {
      try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (_) {}
    };
    const remove = (key) => {
      try { sessionStorage.removeItem(key); } catch (_) {}
    };
    const route = (url) => url.pathname + url.search;
    const revealLink = (nav, link) => {
      if (!link || nav.scrollWidth <= nav.clientWidth) return;
      const navRect = nav.getBoundingClientRect();
      const linkRect = link.getBoundingClientRect();
      const left = navRect.left + nav.clientLeft;
      const right = left + nav.clientWidth;
      if (linkRect.left < left) nav.scrollLeft -= Math.ceil(left - linkRect.left);
      else if (linkRect.right > right) nav.scrollLeft += Math.ceil(linkRect.right - right);
    };
    const revealActive = (state) => revealLink(state.nav, state.nav.querySelector('a[aria-current="page"]'));
    const save = (state) => {
      state.routeKey = 'xfun-category:' + state.collection.pathname + ':route:' + route(new URL(location.href));
      write(state.routeKey, { left: state.nav.scrollLeft });
    };
    const roots = (root) => [...(root.matches?.('[data-xfun-category-nav]') ? [root] : []), ...root.querySelectorAll('[data-xfun-category-nav]')];
    const initialize = (root) => {
      roots(root).forEach((nav) => {
        if (states.has(nav)) return;
        let collection;
        try { collection = new URL(nav.dataset.collectionUrl, location.origin); } catch (_) { return; }
        const currentRoute = route(new URL(location.href));
        const prefix = 'xfun-category:' + collection.pathname;
        const routeKey = prefix + ':route:' + currentRoute;
        const transferKey = prefix + ':transfer';
        const stored = read(routeKey);
        const transfer = read(transferKey);
        const transferred = transfer?.route === currentRoute && Number.isFinite(transfer.at) && Date.now() - transfer.at < 30000;
        const previous = transferred ? transfer : stored;
        if (transferred || transfer && Date.now() - transfer.at >= 30000) remove(transferKey);
        const restored = previous && Number.isFinite(previous.left) && previous.left >= 0;
        const state = { nav, routeKey, transferKey, collection, controller: new AbortController(), interacted: false, alive: true, frame: 0, width: nav.clientWidth };
        states.set(nav, state);
        activeStates.add(state);
        if (restored) nav.scrollLeft = previous.left;
        if (!restored || transferred) revealActive(state);
        save(state);
        const options = { signal: state.controller.signal };
        const interact = () => { state.interacted = true; };
        nav.addEventListener('pointerdown', interact, { ...options, passive: true });
        nav.addEventListener('touchstart', interact, { ...options, passive: true });
        nav.addEventListener('wheel', interact, { ...options, passive: true });
        nav.addEventListener('keydown', interact, options);
        nav.addEventListener('focusin', (event) => {
          interact();
          const link = event.target instanceof Element ? event.target.closest('a') : null;
          if (link && nav.contains(link)) revealLink(nav, link);
        }, options);
        nav.addEventListener('scroll', () => {
          if (state.frame) return;
          state.frame = requestAnimationFrame(() => { state.frame = 0; save(state); });
        }, { ...options, passive: true });
        nav.addEventListener('click', (event) => {
          save(state);
          if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const link = event.target instanceof Element ? event.target.closest('a') : null;
          if (!link || !nav.contains(link) || link.target && link.target !== '_self' || link.hasAttribute('download')) return;
          let target;
          try { target = new URL(link.href, location.href); } catch (_) { return; }
          const sameCollection = target.origin === location.origin && (target.pathname === collection.pathname || target.pathname.startsWith(collection.pathname + '/'));
          if (sameCollection) write(transferKey, { route: route(target), left: nav.scrollLeft, at: Date.now() });
        }, options);
        if (document.fonts && (!restored || transferred)) document.fonts.ready.then(() => {
          if (state.alive && nav.isConnected && !state.interacted) {
            revealActive(state);
            save(state);
          }
        });
      });
    };
    const destroy = (nav) => {
      const state = states.get(nav);
      if (!state) return;
      save(state);
      state.alive = false;
      state.controller.abort();
      cancelAnimationFrame(state.frame);
      activeStates.delete(state);
      states.delete(nav);
    };
    window.XfunCategoryNavigation = { initialize };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    else initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => roots(event.target).forEach(destroy));
    window.addEventListener('pagehide', () => activeStates.forEach(save));
    window.addEventListener('pageshow', () => initialize(document));
    let resizeFrame = 0;
    window.addEventListener('resize', () => {
      if (resizeFrame) return;
      resizeFrame = requestAnimationFrame(() => {
        resizeFrame = 0;
        activeStates.forEach((state) => {
          if (!state.nav.isConnected) { destroy(state.nav); return; }
          if (state.width !== state.nav.clientWidth) {
            state.width = state.nav.clientWidth;
            revealActive(state);
            save(state);
          }
        });
      });
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
